import { useNavigate } from 'react-router-dom';
import './LocationSection.css';

const schedule = [
  { day: 'Lunes – Viernes', hours: '8:30 – 12:00 / 13:30 – 18:00' },
  { day: 'Sábado', hours: '8:30 – 12:00 / 13:30 – 18:00' },
  { day: 'Domingo', hours: 'Cerrado' },
];

interface LocationSectionProps { onBooking: () => void; }

export default function LocationSection({ onBooking }: LocationSectionProps) {
  const navigate = useNavigate();
  return (
    <section id="contacto" className="location-section py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="location-section-label mb-4">◆ Ubicación ◆</p>
          <h2 className="location-section-title">Encuéntranos</h2>
          <div className="location-section-divider" />
        </div>
        <div className="location-container">
          <div className="location-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3921.2!2d-74.7826992!3d10.94983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef42d5b2e1f0001%3A0x1!2sCalle+27b+%2311-47%2C+Barranquilla%2C+Colombia!5e0!3m2!1ses!2sco!4v1711000000002"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa Barber Studio Luisfer"
            />
          </div>
          <div className="location-info">
            <div className="location-info-block">
              <div className="location-info-header">
                <div className="location-info-icon">
                  <i className="ri-map-pin-2-fill" />
                </div>
                <p className="location-info-label">Dirección</p>
              </div>
              <address className="location-address">Calle 27b # 11-47<br />Barranquilla, Colombia</address>
            </div>
            <div className="location-info-block">
              <div className="location-info-header">
                <div className="location-info-icon">
                  <i className="ri-time-fill" />
                </div>
                <p className="location-info-label">Horario</p>
              </div>
              <div className="location-schedule">
                {schedule.map((s) => (
                  <div key={s.day} className="location-schedule-item">
                    <span className="location-schedule-day">{s.day}</span>
                    <span className={`location-schedule-hours ${s.hours === 'Cerrado' ? 'location-schedule-hours-closed' : 'location-schedule-hours-open'}`}>
                      {s.hours}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="location-info-block">
              <div className="location-info-header">
                <div className="location-info-icon">
                  <i className="ri-phone-fill" />
                </div>
                <p className="location-info-label">Contacto</p>
              </div>
              <div className="location-contact">
                <a href="tel:+573000000000" className="location-contact-link">+57 300 000 0000</a>
                <a href="mailto:info@barberstudioluisfer.com" className="location-contact-link-muted break-all">info@barberstudioluisfer.com</a>
              </div>
            </div>
            <button onClick={() => navigate('/reservar')} className="location-cta cursor-pointer">
              Reservar Cita
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}